export function distinct(array, propertyName) {
    const result = [];
    const map = new Map();
    for (const item of array) {
        if (!map.has(item[propertyName])) {
            map.set(item[propertyName], true);
            result.push(item);
        }
    }

    return result;
}